export default "__VITE_ASSET__CWmbqb8g__"